import { Chip, Stack, Typography } from "@mui/material";
import type { AppConfig } from "../types";
import { AppName } from "./configuration/app-config-table";

interface AppConfigDisplayProps {
  appConfig: AppConfig;
  showChip?: boolean;
}

export const AppConfigDisplay = ({ appConfig, showChip = true }: AppConfigDisplayProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      width="100%"
    >
      <Stack direction="column" spacing={0} alignItems="flex-start">
        <AppName appConfig={appConfig} />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            fontSize: "0.75rem",
            fontFamily: "Geist, -apple-system, BlinkMacSystemFont, sans-serif",
          }}
        >
          {appConfig.base_url ?? "about:blank"}
        </Typography>
      </Stack>
      {showChip && <Chip label={appConfig.cfg_type ?? "legacy"} size="small" />}
    </Stack>
  );
};
